module.exports = __webpack_public_path__ + "img/ez-slot-category-fishing-game-hover.6f64d8eb.png";